import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import * as _ from 'lodash';

import GoalsList from '../goals/List';
import CreateGoals from '../goals/create/';
import Button from '../common/Button';
import * as DateService from '../utils/date';
import { scrollToHash } from '../utils/scrollToHash';

import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import 'react-web-tabs/dist/react-web-tabs.css';

class Goals extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      createModeEnabled: false,
    };
  }

  componentDidMount() {
    scrollToHash();
  }

  getDefaultYear = (years) => {
    if (_.isEmpty(years)) {
      return '';
    }

    const thisYear = DateService.getHumanizedYear(new Date().valueOf());

    return years.find((y) => y === thisYear) || years[0];
  };

  renderBody = () => {
    const { user, isCurrentUser, t } = this.props;

    if (!user) {
      return null;
    }

    if (_.isEmpty(user.goals)) {
      if (isCurrentUser) {
        return <GoalsList user={user} />;
      } else {
        return t('goal.noGoals');
      }
    }

    const years = [
      ...new Set(user.goals.map((g) => DateService.getHumanizedYear(g.dueAt))),
    ];
    years.sort((a, b) => parseInt(b, 10) - parseInt(a, 10));

    return (
      <Tabs
        defaultTab={`vertical-tab-${this.getDefaultYear(years)}`}
        vertical
        className="u-margin-bottom-huge rwt__tab--small"
        // Ugly fix: textare doesn't auto-resizes when it is hidden initially.
        // This forces the textareas to always auto-resize, no matter what.
        onChange={() =>
          setTimeout(() => window.dispatchEvent(new Event('resize'), 1))
        }
      >
        <TabList className="rwt__tablist--small">
          {years.map((y) => (
            <Tab
              key={y}
              type="button"
              className="rwt__tab--small"
              tabFor={`vertical-tab-${y}`}
            >
              {y}
            </Tab>
          ))}
        </TabList>
        {years.map((y) => (
          <TabPanel
            key={y}
            tabId={`vertical-tab-${y}`}
            className="rwt__tabpanel--small"
          >
            <GoalsList
              user={{
                ...user,
                goals: _.isEmpty(user.goals)
                  ? []
                  : user.goals.filter(
                      (g) => DateService.getHumanizedYear(g.dueAt) === y
                    ),
              }}
            />
          </TabPanel>
        ))}
      </Tabs>
    );
  };

  render() {
    const { isCurrentUser, t } = this.props;
    const { createModeEnabled } = this.state;

    return (
      <div className="u-margin-bottom-huge">
        <h3>
          <span className="u-color-fountain-blue">
            {t('user.goalsTitlePrefix')}
          </span>
          {t('user.goalsTitle')}
          <span className="u-color-fountain-blue">
            {t('user.goalsTitleSuffix')}
          </span>
        </h3>
        {this.renderBody()}

        {!createModeEnabled &&
          isCurrentUser && (
            <Button
              styleType="outline"
              onClick={() => this.setState({ createModeEnabled: true })}
            >
              {t('goal.create.addGoal')}
            </Button>
          )}

        {createModeEnabled &&
          isCurrentUser && (
            <div className="o-box c-box o-box--with-vertical-indent">
              <CreateGoals
                onCancel={() => this.setState({ createModeEnabled: false })}
                autoFocus={true}
              />
            </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = ({ user: currentUser }, { user }) => ({
  isCurrentUser: currentUser.data._id === user._id,
  // All right, that's a tricky one. When I ref the user from props only,
  // it doesn't trigger component re-rendering. Therefore,
  // when I update current user goals, they don't re-render.
  // So if it is the current user - ref from the redux state.
  // This way, it re-renders.
  user: currentUser.data._id === user._id ? currentUser.data : user,
});

export default connect(mapStateToProps)(translate()(Goals));



// WEBPACK FOOTER //
// ./src/user/Goals.js